var _require = require('humps'),
  pascalize = _require.pascalize;
import * as interactions from '@instructure/quiz-interactions';
var slugToNameMap = {
  'multi-answer': 'MultipleAnswer',
  choice: 'MultipleChoice'
};
export var componentForItem = function componentForItem(intTypeSlug, usage) {
  var componentKey = slugToNameMap[intTypeSlug];
  if (!componentKey) {
    componentKey = pascalize(intTypeSlug);
  }
  var normalizedUsage = pascalize(usage.toLowerCase());
  var componentName = componentKey + normalizedUsage;
  var component = interactions[componentName];
  if (!component) {
    throw new Error("Unable to find component: ".concat(componentName));
  }
  return component;
};
export default componentForItem;